import { object, ObjectSchemaDefinition } from 'yup';

export const objectShape = (obj: ObjectSchemaDefinition<any>, name: string) => {
  return object()
    .shape(obj)
    .noUnknown(true, `${name} has unknown property`);
};
